// assets
import { IconFileText } from '@tabler/icons';
const groupBy = {
  id: 'menu',
  title: 'Tracking',
  type: 'group',
  children: [
    {
      id: 'keyword-tracking',
      title: 'Keyword Tracking',
      type: 'item',
      url: '/keyword-tracking',
      icon: IconFileText,
      breadcrumbs: false,
      role: [2, 4],
      display: false
    }
  ]
};

export default groupBy;
